import {Column, Entity, PrimaryGeneratedColumn} from "typeorm"

@Entity()
export class VpnMap {
	@PrimaryGeneratedColumn('increment')
	id!: number;

	@Column({nullable : true})
  container_name!: string

	@Column({nullable : true})
  vpn_certificate!: string

  @Column({nullable : true})
  vpn_dockerfile!: string

  @Column({nullable : true})
  vpn_port!: string

  @Column({nullable : true})
  username!: string

  @Column({nullable : true})
  password!: string

  @Column({nullable : true})
  kami_host!: string

  @Column({nullable : true})
  vpn_host!: string
}